'use client';
import { useState, useEffect } from 'react';
import { IRepository, IResourceVersion } from '@/types';

import { IDfQueryResponse } from '@/lib/dataframeQueryApi';
import { IDataFrameField } from '@/lib/dataFrameTypes';

import QueryTools from '@/components/DataFrame/QueryTools';
import useDataframeQuery from '@/hooks/useDataframeQuery';
import useDataframeQueryContext from '@/components/DataFrame/DataframeQueryContext';

const QueryControl: React.FC<{
  repository: IRepository;
  resource: IResourceVersion;
  queryResponse?: IDfQueryResponse;
  children?: React.ReactNode;
}> = ({ repository, resource, queryResponse, children }) => {
  const [queryId, setQueryId] = useState<string | undefined>(queryResponse?.query?.id);

  const { onQueryIdChange, onQueryClear } = useDataframeQueryContext();

  const { query, queryQuotaUsage, isLoading, fetchQueryByNlp, fetchQueryBySql, clearQuery } = useDataframeQuery({
    repository,
    queryId,
    initialData: queryResponse,
    resource: { version: resource.version, path: resource.path },
  });

  useEffect(() => {
    setQueryId(query?.id);
  }, [query?.id]);

  useEffect(() => {
    setQueryId(queryId);
    onQueryIdChange(queryId);
  }, [queryId]);

  const doQueryClear = () => {
    clearQuery();
    onQueryClear();
  };

  const refetchQueryByNlp = (value: string) => {
    fetchQueryByNlp(value, true);
    console.log('refetchQuery', value);
  };

  const fields = query?.schema.split(',').map((item) => {
    const [name, type] = item.split(':');
    return { name, dtype: type, metadata: null } as IDataFrameField;
  });

  const schema = fields ? { fields } : undefined;

  return (
    <QueryTools
      query={query}
      queryQuotaUsage={queryQuotaUsage}
      disabled={isLoading}
      onQueryClear={doQueryClear}
      onNlpChange={fetchQueryByNlp}
      onSqlChange={fetchQueryBySql}
      onRefetch={refetchQueryByNlp}
      schema={schema}
    >
      {children}
    </QueryTools>
  );
};

export default QueryControl;
